import isIEbrowser from '../../../resources/scripts/helpers/is-IE';

class FlexibleImageGrid {
  static init(...parameters) {
    return new FlexibleImageGrid(...parameters);
  }

  constructor(container) {
    this.container = container;
    if (container) {
      this.animationHasRun = false;
      this.content = container.querySelector('.content');
      this.images = container.querySelectorAll('.image');
      const IE = isIEbrowser();

      if (IE && this.content) {
        this.content.classList.add('-IE');
        if (this.images) {
          for (let i = 0; i < this.images.length; i += 1) {
            this.images[i].parentNode.style.height = `${this.images[i].clientHeight}px`;
          }
        }
      }

      //  Animation options
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      };


      const callback = (event) => {
        if (event[0].isIntersecting && !this.animationHasRun) {
          if (this.content) {
            this.content.classList.add('-finished');
            this.animationHasRun = true;
          }
        }
      };

      if (!IE) {
        if (this.container && this.content) {
          this.content.classList.add('-transition');
          const observer = new IntersectionObserver(callback, options);
          observer.observe(this.container);
        }
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-flexible-image-grid', FlexibleImageGrid.init);
}
